import React, { useState, useEffect, lazy, Suspense } from "react";

import { Container, Grid } from "@material-ui/core";

import { NavLink, matchPath, useRouteMatch } from "react-router-dom";

const SearchBar = lazy(() =>
  import(/* webpackChunkName: 'srchbar'*/ "../parts/SearchBar")
);
import UserMenu from "./UserMenu";
//import SiteMenu from "./SiteMenu";
const JangoLogoSVG = lazy(() =>
  import(
    /*webpackChunkName: "jnglgsvg" */ "svg/JangoLogoCurrentColor_320x121.svg"
  )
);
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Menu = () => {
  const [headerClassName, setHeaderClassName] = useState("");
  const [selectedSearch, setSelectedSearch] = useState(false);

  const handleScroll = (headerClassName) => {
    if (headerClassName !== "menuscroll" && window.pageYOffset >= 144) {
      setHeaderClassName("menuscroll");
    } else if (
      headerClassName === "menuscroll" &&
      window.pageYOffset < 50 &&
      !document.querySelector(".ovrflw")
    ) {
      setHeaderClassName("");
    }
  };

  useEffect(() => {
    window.onscroll = () => {
      handleScroll(headerClassName);
    };
  }, [headerClassName]);

  return (
    <div id="header" className={headerClassName}>
      <div id="menu-spacer"></div>
      <div
        id="menu"
        className={`dark-bg ${selectedSearch && "searchingContainer"}`}
      >
        <Container fixed className={selectedSearch ? "searching" : ""}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="space-between"
            id="IE-menu-container"
          >
            <Grid item md className="pt-1 pb-2 pt-md-0 pb-md-0 top-row-mobile">
              <Suspense fallback={null}>
                <NavLink exact={true} to="/" title="Now Playing">
                  <JangoLogoSVG
                    id="main-logo"
                    style={{ transition: "all 1s ease-in-out" }}
                  />
                </NavLink>
              </Suspense>
            </Grid>
            <Grid item md className="order-md-2 pr-0 top-row-mobile">
              <Grid container justifyContent="flex-end" alignItems="center">
                <Grid item>
                  <Suspense fallback={null}>
                    <SearchBar
                      selected={selectedSearch}
                      setSelected={setSelectedSearch}
                    />
                  </Suspense>
                </Grid>
                {/*                <Grid item id="menu-user" className="pl-3">
                  <FontAwesomeIcon icon="user-circle" className="icon-action" />
                </Grid>*/}
                <Grid item id="menu-user" className="pl-3">
                  <UserMenu />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              className="order-md-1 pt-3 pt-md-0 bottom-row-mobile"
              id="IE-main-menu-items-wrapper"
            >
              <Grid
                container
                id="main-menu-items"
                className="justify-content-center"
              >
                <MainMenuItem title="Now Playing" link="/" />
                <MainMenuItem
                  title="Explore"
                  link="/browse_music/genre/Recommended"
                  matchPaths={["/browse_music/genre/:genre"]}
                  id="menu-explore-stations"
                />
                <MainMenuItem
                  title="My Stations"
                  link="/my_stations"
                  matchPaths={[
                    "/my_mixes",
                    "/users/:user_id/mixes/new",
                    "/my_stations",
                    "/my_independent_artists",
                    "/song_ratings/favorites",
                    "/users/:user_id/stations",
                    "/guests/history",
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

const MainMenuItem = ({ link, title, id, matchPaths }) => {
  const match = useRouteMatch();

  return (
    <Grid item xs md="auto" className="pr-md-3 pl-md-3">
      <NavLink
        exact={link == "/"}
        to={link}
        className="main-menu-item"
        activeClassName="selected"
        id={id}
        isActive={(match, currentLocation) => {
          if (
            ["/my_stations", "/browse_music/genre/Recommended"].includes(link)
          ) {
            return matchPath(currentLocation.pathname, { path: matchPaths });
          } else {
            return match;
          }
        }}
      >
        {title}
      </NavLink>
    </Grid>
  );
};

export default Menu;
